export default {"src":"https://fishbrain.com/_next/static/media/perch.823f7e36.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};